import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {NotificationManager} from 'react-notifications';

import {withUser} from '../../lib/user';
import SideModal from '../../components/SideModal';
import Form from '../../components/Form';
import SubHeader from '../../components/SubHeader';
import Button from '../../components/Button';

class HiddenWidgetsFormModal extends PureComponent {
  state = this.getInitialState();

  getInitialState() {
    return {
      widgetsToUnhide: [],
      selectAll: false
    };
  }

  componentDidUpdate(prevProps) {
    const {template} = this.props;

    if (prevProps.template !== template) {
      this.setState(this.getInitialState());
    }
  }

  handleSaveHiddenWidgets = async () => {
    const {template, onClose, onSave} = this.props;
    let {widgetsToUnhide} = this.state;

    try {
      onSave(widgetsToUnhide);
      if(widgetsToUnhide.length === 1 && widgetsToUnhide.includes(template.id)){
        NotificationManager.success('Your Sheet Context widget was succesfully unhidden!');
      } else if(widgetsToUnhide.length === 1 && !widgetsToUnhide.includes(template.id)){
        NotificationManager.success('Your widget was succesfully unhidden!');
      } else {
        NotificationManager.success('Your widgets were succesfully unhidden!')
      }
    }
    catch (e) {
      NotificationManager.error('An error occurred while unhiding your widget/s. Please try again.');
    }
    this.setState({widgetsToHide:[]});
    onClose();
  }

  handleSelection = (id) => {
    const {template} = this.props;
    let {widgetsToUnhide} = this.state;

    if(id === template.id){
      id = template.id;
    }

    if(widgetsToUnhide.indexOf(id) === -1){
      this.setState({widgetsToUnhide: widgetsToUnhide.concat(id)})
    } else {
      this.setState({widgetsToUnhide: widgetsToUnhide.filter(widget => widget !== id)})
    }
  }
  handleSelectAll = () => {
    const {template} = this.props;
    let {selectAll} = this.state;
    let allQuestions = template.questions.concat(template.widgets)

    if(template.contextWidgetHidden) {
      allQuestions.push({title: 'Sheet Context', id:template.id, hidden: 'true'});
    }

    if(selectAll) {
      this.setState({widgetsToUnhide: [], selectAll: false})
    } else{
      this.setState({widgetsToUnhide: allQuestions.map((question) => question.id), selectAll: true})
    }
  }

  render() {
    const {open, onClose, template} = this.props;
    const {widgetsToUnhide} = this.state;

    let allQuestions = template.questions.concat(template.widgets);

    if(template.contextWidgetHidden) {
      allQuestions.push({title: 'Sheet Context', text: 'Sheet Context', id:template.id, hidden: 'true'});
    }

    allQuestions.forEach(widget => widget.title ? widget.text = widget.title: null);
    allQuestions.sort((a,b) => a.text.trim().toLowerCase().localeCompare(b.text.trim().toLowerCase()));
    let hiddenWidgets = allQuestions.filter((question) => question.hidden)

    return (
      <Form onSubmit={this.handleSaveWidget}>
        <SideModal
          small
          open={open}
          title={'Hidden Widgets'}
          onClose={onClose}
          options={[
            <Button disabled={!widgetsToUnhide.length > 0} onClick={() => this.handleSaveHiddenWidgets()}>{'Unhide Selected'}</Button>,
          ]}>
          {hiddenWidgets.length === 0 ?
            <NoHiddenWidgets>
              <Message>
                <img src="/assets/noHiddenWidgets.svg" alt="" width="200" />
                  <SubHeader center>You have no hidden widgets</SubHeader>
              </Message>
            </NoHiddenWidgets> :  
            <WidgetFormContainer>
              <CheckboxInput key="select-all">
                <input type="checkbox" onChange={() => this.handleSelectAll()}/>
                <b>
                  Select-All 
                </b>
              </CheckboxInput>
              {hiddenWidgets.map((question) =>
                <CheckboxInput key={question.id}>
                  <input type="checkbox" checked={shouldThisBeChecked(question.id, template.id, widgetsToUnhide)} onChange={() => this.handleSelection(question.id)}/>
                  {question.text}
                </CheckboxInput>
              )}
            </WidgetFormContainer>
          } 
        </SideModal>
      </Form>
    );
  }
}

function shouldThisBeChecked(id, templateId, widgetsToUnhide ){
  if(id === templateId) {
    if(widgetsToUnhide.indexOf(templateId) > -1){
      return true;
    }
  } else{
    if(widgetsToUnhide.indexOf(id) > -1){
      return true
    }
  }
  return false;
}

const CheckboxInput = styled.label`
  display: block;
  margin-top: 0.5rem;
  input {
    margin-right: 0.5rem;
  }
`;

const WidgetFormContainer = styled(SideModal.Content)`
  display: flex;
  flex-direction: column;
`;

const NoHiddenWidgets = styled.div`
  height: calc(100vh - 18rem);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  img {
    display: block;
    margin: 0 auto 2rem auto;
  }

  p {
    color: #747474;
    margin-top: 1rem;
    line-height: 1.5;
  }
`;

export default withUser(HiddenWidgetsFormModal);